const ANIMAL_TYPE_PARAM = 'filter.v.t.shopify.animal-type';
const DOG_AGE_GROUP_SELECTOR = 'accordion-custom[data-filter-param-name="filter-v-t-shopify-dog-age-group"]';
const CAT_AGE_GROUP_SELECTOR = 'accordion-custom[data-filter-param-name="filter-v-t-shopify-cat-age-group"]';
const BREED_SIZE_SELECTOR = 'accordion-custom[data-filter-param-name="filter-v-t-shopify-suitable-for-breed-size"]';

let isApplying = false;

function getCheckedAnimalTypeLabels() {
  const checked = document.querySelectorAll(`input[name="${ANIMAL_TYPE_PARAM}"]:checked`);
  return [...checked].map((input) => input.closest('li')?.textContent.trim().toLowerCase() ?? '');
}

function applyConditionalAgeGroupFilters() {
  const labels = getCheckedAnimalTypeLabels();
  const showDog = labels.length === 0 || labels.some((label) => label.includes('perro'));
  const showCat = labels.length === 0 || labels.some((label) => label.includes('gato'));

  isApplying = true;
  document.querySelectorAll(DOG_AGE_GROUP_SELECTOR).forEach((el) => {
    el.hidden = !showDog;
  });
  document.querySelectorAll(CAT_AGE_GROUP_SELECTOR).forEach((el) => {
    el.hidden = !showCat;
  });
  document.querySelectorAll(BREED_SIZE_SELECTOR).forEach((el) => {
    el.hidden = !showDog;
  });
  isApplying = false;
}

// Los filtros se re-renderizan vía fetch (sectionRenderer) en un momento que no
// coincide con ningún evento del tema: un MutationObserver sobre el contenedor
// de filtros es lo único que detecta de forma confiable cuando el DOM nuevo llega.
const filtersContainer = document.querySelector('.facets-block-wrapper')?.parentElement ?? document.body;
const observer = new MutationObserver(() => {
  if (isApplying) return;
  applyConditionalAgeGroupFilters();
});
observer.observe(filtersContainer, { childList: true, subtree: true });

document.addEventListener('change', (event) => {
  if (event.target instanceof HTMLInputElement && event.target.name === ANIMAL_TYPE_PARAM) {
    applyConditionalAgeGroupFilters();
  }
});

applyConditionalAgeGroupFilters();
